module.exports = __webpack_public_path__ + "img/hero-reports-3.a2d528fb.jpg";